// Define and export the different types of role actions
export const ADD_MEMBERSHIP_TIER_REQUEST = 'ADD_MEMBERSHIP_TIER_REQUEST';
export const ADD_MEMBERSHIP_TIER_SUCCESS = 'ADD_MEMBERSHIP_TIER_SUCCESS';
export const ADD_MEMBERSHIP_TIER_FAILURE = 'ADD_MEMBERSHIP_TIER_FAILURE';





export const UPDATE_MEMBERSHIP_TIER_REQUEST = 'UPDATE_MEMBERSHIP_TIER_REQUEST';
export const UPDATE_MEMBERSHIP_TIER_SUCCESS = 'UPDATE_MEMBERSHIP_TIER_SUCCESS';
export const UPDATE_MEMBERSHIP_TIER_FAILURE = 'UPDATE_MEMBERSHIP_TIER_FAILURE';


export const CLEAR_MEMBERSHIP_TIER_ERROR = "CLEAR_MEMBERSHIP_TIER_ERROR";
